import { useVisualContext } from "Contexts/VisualContext";
import { useEffect, useState } from "react";

const useBackgroundUpdate = (style)=>{
  const { setBGStyle, backgroundStyle } = useVisualContext();
  const [bgSet, updateBgSet] = useState(false);
  useEffect(()=>{
    if(bgSet) return;
    if(style === backgroundStyle) return;
    setBGStyle(style);
    updateBgSet(true);
  },[bgSet, updateBgSet, style, setBGStyle, backgroundStyle])
}

export default useBackgroundUpdate;